import type { EventName } from "@lit/react";
import { Grid as GridElement, type GridEventMap as _GridEventMap, } from "@vaadin/grid/vaadin-grid.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { GridElement, };
export type GridEventMap<T1> = Readonly<{
    onActiveItemChanged: EventName<_GridEventMap<T1>["active-item-changed"]>;
    onCellActivate: EventName<_GridEventMap<T1>["cell-activate"]>;
    onColumnResize: EventName<_GridEventMap<T1>["column-resize"]>;
    onExpandedItemsChanged: EventName<_GridEventMap<T1>["expanded-items-changed"]>;
    onLoadingChanged: EventName<_GridEventMap<T1>["loading-changed"]>;
    onItemToggle: EventName<_GridEventMap<T1>["item-toggle"]>;
    onSelectedItemsChanged: EventName<_GridEventMap<T1>["selected-items-changed"]>;
    onCellFocus: EventName<_GridEventMap<T1>["cell-focus"]>;
    onColumnReorder: EventName<_GridEventMap<T1>["column-reorder"]>;
    onGridDragend: EventName<_GridEventMap<T1>["grid-dragend"]>;
    onGridDragstart: EventName<_GridEventMap<T1>["grid-dragstart"]>;
    onGridDrop: EventName<_GridEventMap<T1>["grid-drop"]>;
    onSizeChanged: EventName<CustomEvent<unknown>>;
    onDataProviderChanged: EventName<CustomEvent<unknown>>;
}>;
const events = { onActiveItemChanged: "active-item-changed", onCellActivate: "cell-activate", onColumnResize: "column-resize", onExpandedItemsChanged: "expanded-items-changed", onLoadingChanged: "loading-changed", onItemToggle: "item-toggle", onSelectedItemsChanged: "selected-items-changed", onCellFocus: "cell-focus", onColumnReorder: "column-reorder", onGridDragend: "grid-dragend", onGridDragstart: "grid-dragstart", onGridDrop: "grid-drop", onSizeChanged: "size-changed", onDataProviderChanged: "data-provider-changed" } as GridEventMap<any>;
export type GridProps<T1> = WebComponentProps<GridElement<T1>, GridEventMap<T1>>;
export const Grid = createComponent({
    elementClass: GridElement, events, react: React, tagName: "vaadin-grid"
}) as <T1>(props: GridProps<T1> & React.RefAttributes<GridElement<T1>>) => React.ReactElement | null;
